const core = {
    formatDate(d, format){
        if(d == null || d == "null" || typeof d == "undefined"){
            return ""
        }else{
            const date = new Date(d);
            const time = format == "with time" ? `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}:${date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()}` : "";
            return `${date.getFullYear()}/${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} ${time}`
        }
    }
}

export default core